import { useEffect, useState } from 'react';
import { RequestState } from '../../constants/request-state';
import { loanService } from '../../services/loan.service';
import { Loan } from '../../types/loan/Loan';

export function useLoan(loanId?: number, skip = false) {
    const [requestState, setRequestState] = useState<RequestState>(RequestState.none);
    const [loan, setLoan] = useState<Loan | undefined>(undefined);

    useEffect(() => {
        if (skip || loanId == null) {
            return;
        }

        let cancelled = false;
        setRequestState(RequestState.request);

        loanService
            .getLoan(loanId)
            .then(result => {
                if (cancelled) return;
                setLoan(result);
                setRequestState(RequestState.success);
            })
            .catch(() => {
                if (cancelled) return;
                setRequestState(RequestState.failure);
            });

        return () => {
            cancelled = true;
        };
    }, [loanId, skip]);

    return { requestState, loan };
}
